import type { PricingCampaignModel } from '@/shared/generated'

import { Slot } from '@radix-ui/react-slot'

import { useModals } from '@/shared/lib/modal-manager'

type Props = {
	children: React.ReactNode
	pricingCampaign: PricingCampaignModel
}
/**
 * Dublicate Pricing Campaign to external global PC set
 */
export const DuplicatePricingCampaignTo = ({
	children,
	pricingCampaign,
}: Props) => {
	const { showModal } = useModals()
	const handleOpenModal = () => {
		showModal('DUBLICATE_PRICING_CANPAIGNS_TO_GLOBAL_PC_SET', {
			pricingCampaign,
		})
	}

	return <Slot onClick={handleOpenModal}>{children}</Slot>
}
